import CloseIcon from '@svg/close.svg';

import {
  GroupBase,
  MultiValueProps,
} from '../../types';

import s from './MultiValue.sss';

export function MultiValue<
Option,
IsMulti extends boolean = false,
Group extends GroupBase<Option> = GroupBase<Option>,
>({
  removeProps,
  children,
}: MultiValueProps<Option, IsMulti, Group>) {
  return (
    <div className={s.tag}>
      <span className={s.tagText}>
        {children}
      </span>
      <div
        {...removeProps}
        className={s.tagButton}
        onTouchEnd={
          (e) => {
            if (removeProps.onClick) {
              removeProps.onClick(e as never);
            }
          }
        }
      >
        <CloseIcon
          width="20"
          height="20"
        />
      </div>
    </div>
  );
}
